import React from 'react';

export function PublicCompetitionClubs({ competitionName }) {
    return (
        <div>
            <h3>Vereine für {competitionName}</h3>
            <p>Hier werden die Vereine angezeigt.</p>
            {/* TODO: Vereine-Logik implementieren */}
        </div>
    );
}
